import { Person } from '@mui/icons-material'
import React from 'react'
import { ChildrenMultiSelect } from './ChildrenMultiSelect'
import { FamilySelector } from './FamilySelector'
import { ValidationButton } from './ValidationButton'
import { useSellerSelection } from './hooks/useSellerSelection'
import { useChildSelectorControl } from './hooks/sellerSelection/useChildSelectorControl'
import { useSellerValidation } from './hooks/sellerSelection/useSellerValidation'

const VALIDATION_HINT_MESSAGE = 'Avez-vous pensé à valider votre sélection ?'

type ChildSelectorFieldProps = {
  params: Parameters<typeof useChildSelectorControl>[0]
  onDropdownStateChange: (isOpen: boolean) => void
}

const ChildSelectorField: React.FC<ChildSelectorFieldProps> = ({
  params,
  onDropdownStateChange,
}) => {
  const control = useChildSelectorControl(params)

  React.useEffect(() => {
    onDropdownStateChange(control.dropdownBehavior.isChildDropdownOpen)
  }, [control.dropdownBehavior.isChildDropdownOpen, onDropdownStateChange])

  return <ChildrenMultiSelect {...control.props} />
}

const NavBarSellerSection = () => {
  const {
    shouldHideSellerSelection,
    familySelectorParams,
    isOrphanSelected,
    childSelectorParams,
    validationParams,
  } = useSellerSelection()

  const [isChildDropdownOpen, setIsChildDropdownOpen] = React.useState(false)

  React.useEffect(() => {
    if (isOrphanSelected) {
      setIsChildDropdownOpen(false)
    }
  }, [isOrphanSelected])

  const validation = useSellerValidation({
    hasPendingSelection: validationParams.hasPendingSelection,
    isChildrenLoading: validationParams.isChildrenLoading,
    isChildDropdownOpen,
    onValidate: validationParams.onValidate,
  })

  if (shouldHideSellerSelection) {
    return null
  }

  return (
    <>
      <FamilySelector {...familySelectorParams} />

      <Person className="ml-3" />
      <ChildSelectorField
        params={childSelectorParams}
        onDropdownStateChange={setIsChildDropdownOpen}
      />

      <ValidationButton
        showHint={validation.showValidationHint}
        hasPendingSelection={validation.hasPendingSelection}
        isChildrenLoading={validation.isChildrenLoading}
        hintMessage={VALIDATION_HINT_MESSAGE}
        onValidate={validation.handleValidate}
      />
    </>
  )
}

export default NavBarSellerSection
